import axios from 'axios';
import { map, omitBy, isEmpty, isNil, omit, find } from 'lodash';
import { apiURL } from '../helpers';
import { errorHandler } from '../utils';
import { getAccessToken, getProfileID } from 'Helpers/session';
import normalize from 'Utils/normalizer';

export const fetchChatToken = async (profileID) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/chat/token/fetch`;

  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: {
        profileID: profileID
      },
      headers: { 'Authorization': `Bearer ${accessToken}` }
    })

    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const { value, code, message, stack } = await errorHandler.response(error);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}

export const fetchUserListInfo = async (
  filters: any
) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/user/list`;

  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ filters: filters }, isNil),
      headers: { 'Authorization': `Bearer ${token}` }
    })
    return response.data
  }
  catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(error)
    if (!isEmpty(error)) {
      const callback = async () => await fetchUserListInfo(filters)
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}

export const fetchConvesationList = async (filters) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/conversation/list`;
  const profileID = getProfileID()
  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: { filters: filters },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    return !isEmpty(response.data.conversations) ? response.data.conversations : [];

    // return !isEmpty(response.data.conversations) ?
    //   map(response.data.conversations, conversation => {
    //     if (profileID == conversation.user_from_data.refID) {
    //       conversation.name = conversation.user_to_data.nickName;
    //       conversation.imageUrl = conversation.user_to_data.photo ? conversation.user_to_data.photo.file_url : null;
    //       conversation._id = conversation.conversationID
    //     } else {
    //       conversation.name = conversation.user_from_data.nickName;
    //       conversation.imageUrl = conversation.user_from_data.photo ? conversation.user_from_data.photo.file_url : null;
    //       conversation._id = conversation.conversationID
    //     }
    //     return conversation;
    //   }) : [];
  }
  catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(error)
    if (!isEmpty(error)) {
      const callback = async () => await fetchConvesationList(filters)
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}


export const createConversationByUser = async (obj) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/chat/conversationID/create`;

  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: obj,
      headers: { 'Authorization': `Bearer ${accessToken}` }
    })

    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await createConversationByUser(obj);
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}

export const fetchConvesationUsersList = async (conversationIds) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/conversation/user/list`;
  const profileID = getProfileID()
  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: conversationIds,
      headers: { 'Authorization': `Bearer ${token}` }
    })
    return !isEmpty(response.data.conversations) ?
      map(response.data.conversations, conversation => {
        conversation.unreadCnt = conversation?.total_unread || 0;
        conversation.lastMsg = conversation.metadata?.latestMessage?.text;
        conversation.createdAt = conversation?.metadata?.total_unread ? conversation?.metadata?.lastMsgCreatedAt : '2000-01-05T07:59:21.328Z';


        if (profileID == conversation.user_from_data.refID) {
          conversation.name = conversation.user_to_data.nickName;
          conversation.imageUrl = conversation.user_to_data.photo ? conversation.user_to_data.photo.file_url : null;
          conversation._id = conversation.conversationID;
          conversation.refID = conversation.user_to_data.refID
        } else {
          conversation.name = conversation.user_from_data.nickName;
          conversation.imageUrl = conversation.user_from_data.photo ? conversation.user_from_data.photo.file_url : null;
          conversation._id = conversation.conversationID;
          conversation.refID = conversation.user_from_data.refID
        }
        return conversation;
      }) : [];
  }
  catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(error)
    if (!isEmpty(error)) {
      const callback = async () => await fetchConvesationUsersList(conversationIds)
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}


export const createMessage = async (data) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/message/create`;

  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: data,
      headers: { 'Authorization': `Bearer ${token}` }
    })

    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await createMessage(data);
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}


export const fetchMessages = async (obj) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/message/list`;

  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: { filters: obj, sorting: { sortBy: 'createdAt', mode: 'ASC' } },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    return !isEmpty(response.data.messages) ?
      map(response.data.messages, message => {
        return normalize.response.messages(message)
      }) : { unreadCount: 0, messages: [] };
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchMessages(obj);
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}


export const updateMessageList = async (data) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/message/readby/update`;

  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: data,
      headers: { 'Authorization': `Bearer ${token}` }
    })
    // response.data = response.data.message = {
    //   direction: 'outgoing'
    // }
    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await createMessage(data);
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}

export const checkUserOnline = async (obj) => {

  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/onlineuser/check`;

  const token = localStorage.getItem('CHAT_TOKEN')

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: obj,
      headers: { 'Authorization': `Bearer ${token}` }
    })

    return response.data;
  }
  catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await checkUserOnline(obj);
      const { value, code, message, stack } = await errorHandler.response(error, callback);
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }

}